import { createFileRoute } from '@tanstack/react-router'

import { ShiftsPage } from '@/pages/shifts-page'

export const Route = createFileRoute('/_master-layout/_dashboard-layout/shifts/')({
    component: ShiftsPage,
})
